import axios from "./Axios";
import { returnErrors } from "./Errors";
import {
  FETCH_ALL_USERS_SUCCESS,
  FETCH_ALL_USERS_FAIL,
  BAN_USER_SUCCESS,
  BAN_USER_FAIL,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAIL,
  SERVICE_ACCESS_GRANTED_SUCCESS,
  SERVICE_ACCESS_GRANTED_FAIL,
  FETCH_ALL_DEPARTMENTS_SUCCESS,
  FETCH_ALL_DEPARTMENTS_FAIL,
  CREATE_DEPARTMENT_SUCCESS,
  CREATE_DEPARTMENT_FAIL,
  UPDATE_DEPARTMENT_SUCCESS,
  UPDATE_DEPARTMENT_FAIL,
  DELETE_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT_FAIL,
  FETCH_CHAT_TRACKER_USERS_SUCCESS,
  FETCH_CHAT_TRACKER_USERS_FAIL,
  FETCH_CHAT_TRACKER_CONVERSATION_SUCCESS,
  FETCH_CHAT_TRACKER_CONVERSATION_FAIL,
  FETCH_CHAT_TRACKER_STATS_SUCCESS,
  FETCH_CHAT_TRACKER_STATS_FAIL,
  BULK_ASSIGN_DEPARTMENTS_SUCCESS,
  BULK_ASSIGN_DEPARTMENTS_FAIL,
  ASSIGN_USER_DEPARTMENTS_SUCCESS,
  ASSIGN_USER_DEPARTMENTS_FAIL,
  REMOVE_USER_DEPARTMENT_SUCCESS,
  REMOVE_USER_DEPARTMENT_FAIL,
  FETCH_USER_DEPARTMENTS_SUCCESS,
  FETCH_USER_DEPARTMENTS_FAIL,
  CHANGE_ROLE_SUCCESS,
  CHANGE_ROLE_FAIL,
  MANUAL_CREATE_USER_SUCCESS,
  MANUAL_CREATE_USER_FAIL,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
} from "./Types";

export const FetchAllUsersAction =
  (id = 1, search = "") =>
  async (dispatch) => {
    try {
      const params = new URLSearchParams({ page: id });
      if (search) params.set("search", search);
      const res = await axios.get(`/api/admin-user/list-all-users/?${params.toString()}`);
      dispatch({
        type: FETCH_ALL_USERS_SUCCESS,
        payload: res.data,
      });
      return res.data;
    } catch (err) {
      dispatch(returnErrors(err.response?.data, err.response?.status));
      dispatch({
        type: FETCH_ALL_USERS_FAIL,
        payload: err.response?.data,
      });
    }
  };

export const BanAndUnbanUserAction = (email, banned) => async (dispatch) => {
  try {
    const res = await axios.post("/api/admin-user/update-ban-status/", {
      email,
      banned,
    });
    dispatch({
      type: BAN_USER_SUCCESS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({
      type: BAN_USER_FAIL,
      payload: err.response?.data,
    });
    throw err;
  }
};

export const FetcIndividualUserAction = (email) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/admin-user/fetch-user/${email}`);

    dispatch({
      type: FETCH_USER_SUCCESS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({
      type: FETCH_USER_FAIL,
      payload: err.response?.data,
    });
  }
};

export const grantAccessToServicesAction = (data) => async (dispatch) => {
  try {
    const res = await axios.post("/api/admin-user/service-access/", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    dispatch({
      type: SERVICE_ACCESS_GRANTED_SUCCESS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    console.error("API Error:", err.response); // For debugging
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({
      type: SERVICE_ACCESS_GRANTED_FAIL,
      payload: err.response?.data,
    });
  }
};

export const FetchAllDepartmentsAction = () => async (dispatch) => {
  try {
    const res = await axios.get("/api/admin-user/departments/");
    dispatch({
      type: FETCH_ALL_DEPARTMENTS_SUCCESS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({
      type: FETCH_ALL_DEPARTMENTS_FAIL,
      payload: err.response?.data,
    });
  }
};

export const CreateDepartmentAction = (data) => async (dispatch) => {
  try {
    const res = await axios.post("/api/admin-user/departments/create/", data);
    dispatch({
      type: CREATE_DEPARTMENT_SUCCESS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({
      type: CREATE_DEPARTMENT_FAIL,
      payload: err.response?.data,
    });
  }
};

export const UpdateDepartmentAction =
  (department_id, data) => async (dispatch) => {
    try {
      const res = await axios.put(
        `/api/admin-user/departments/${department_id}/update/`,
        data
      );
      dispatch({
        type: UPDATE_DEPARTMENT_SUCCESS,
        payload: res.data,
      });
      return res.data;
    } catch (err) {
      dispatch(returnErrors(err.response?.data, err.response?.status));
      dispatch({
        type: UPDATE_DEPARTMENT_FAIL,
        payload: err.response?.data,
      });
    }
  };

export const DeleteDepartmentAction = (id) => async (dispatch) => {
  try {
    const res = await axios.delete(`/api/admin-user/departments/${id}/delete/`);
    dispatch({
      type: DELETE_DEPARTMENT_SUCCESS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({
      type: DELETE_DEPARTMENT_FAIL,
      payload: err.response?.data,
    });
  }
};

export const FetchChatTrackerUsersAction = () => async (dispatch) => {
  try {
    const res = await axios.get(`/api/ai/admin/users/`);
    dispatch({
      type: FETCH_CHAT_TRACKER_USERS_SUCCESS,
      payload: res.data,
    });

    return res.data;
  } catch (err) {
    dispatch({
      type: FETCH_CHAT_TRACKER_USERS_FAIL,
      payload: {
        msg: err.response?.data?.msg || "Error fetching chat tracker users",
      },
    });

    return null;
  }
};

export const FetchChatTrackerConversationAction =
  (userId) => async (dispatch) => {
    try {
      const response = await axios.get(
        `/api/ai/admin/users/${userId}/sessions/`
      );

      dispatch({
        type: FETCH_CHAT_TRACKER_CONVERSATION_SUCCESS,
        payload: response.data,
      });

      return response.data;
    } catch (error) {
      dispatch({
        type: FETCH_CHAT_TRACKER_CONVERSATION_FAIL,
        payload: error.response
          ? error.response.data
          : "Error fetching conversation data",
      });

      return error.response
        ? error.response.data
        : "Error fetching conversation data";
    }
  };

export const FetchChatTrackerStatsAction = () => async (dispatch) => {
  try {
    const res = await axios.get("/api/ai/admin/stats/");
    dispatch({
      type: FETCH_CHAT_TRACKER_STATS_SUCCESS,
      payload: res.data,
    });

    return res.data;
  } catch (err) {
    dispatch({
      type: FETCH_CHAT_TRACKER_STATS_FAIL,
      payload: {
        msg:
          err.response?.data?.msg || "Error fetching chat tracker statistics",
      },
    });

    return null;
  }
};

export const BulkAssignDepartmentstoUsersAction =
  (data) => async (dispatch) => {
    try {
      const res = await axios.post(
        "/api/admin-user/bulk-assign-department/",
        data
      );
      dispatch({
        type: BULK_ASSIGN_DEPARTMENTS_SUCCESS,
        payload: res.data,
      });
      return res.data;
    } catch (err) {
      dispatch(returnErrors(err.response?.data, err.response?.status));
      dispatch({
        type: BULK_ASSIGN_DEPARTMENTS_FAIL,
        payload: err.response?.data,
      });
    }
  };

// Multi-department assignment actions
export const AssignUserDepartmentsAction =
  (email, departmentIds) => async (dispatch) => {
    try {
      const res = await axios.post("/api/admin-user/assign-departments/", {
        email,
        department_ids: departmentIds,
      });
      dispatch({
        type: ASSIGN_USER_DEPARTMENTS_SUCCESS,
        payload: res.data,
      });
      return res.data;
    } catch (err) {
      dispatch(returnErrors(err.response?.data, err.response?.status));
      dispatch({
        type: ASSIGN_USER_DEPARTMENTS_FAIL,
        payload: err.response?.data,
      });
      throw err;
    }
  };

export const RemoveUserDepartmentAction =
  (email, departmentId) => async (dispatch) => {
    try {
      const res = await axios.post("/api/admin-user/remove-department/", {
        email,
        department_id: departmentId,
      });
      dispatch({
        type: REMOVE_USER_DEPARTMENT_SUCCESS,
        payload: res.data,
      });
      return res.data;
    } catch (err) {
      dispatch(returnErrors(err.response?.data, err.response?.status));
      dispatch({
        type: REMOVE_USER_DEPARTMENT_FAIL,
        payload: err.response?.data,
      });
      throw err;
    }
  };

export const FetchUserDepartmentsAction = (email) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/admin-user/user-departments/${email}/`);
    dispatch({
      type: FETCH_USER_DEPARTMENTS_SUCCESS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({
      type: FETCH_USER_DEPARTMENTS_FAIL,
      payload: err.response?.data,
    });
    throw err;
  }
};

/**
 * Change a user's role via the unified endpoint.
 * role: "user" | "admin" | "superuser"
 */
export const ChangeRoleAction = (email, role, force = false) => async (dispatch) => {
  try {
    const res = await axios.post("/api/admin-user/change-role/", { email, role, force });
    dispatch({ type: CHANGE_ROLE_SUCCESS, payload: res.data });
    return res.data;
  } catch (err) {
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({ type: CHANGE_ROLE_FAIL, payload: err.response?.data });
    throw err;
  }
};

export const DeleteUserAction = (email) => async (dispatch) => {
  try {
    const res = await axios.delete("/api/admin-user/delete-user/", { data: { email } });
    dispatch({ type: DELETE_USER_SUCCESS, payload: res.data });
    return res.data;
  } catch (err) {
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({ type: DELETE_USER_FAIL, payload: err.response?.data });
    throw err;
  }
};

export const ManualCreateUserAction = (data) => async (dispatch) => {
  try {
    const res = await axios.post("/api/userauth/create-user-manual/", data);
    dispatch({ type: MANUAL_CREATE_USER_SUCCESS, payload: res.data });
    return res.data;
  } catch (err) {
    dispatch(returnErrors(err.response?.data, err.response?.status));
    dispatch({ type: MANUAL_CREATE_USER_FAIL, payload: err.response?.data });
    throw err;
  }
};

export const BulkAssignMultipleDepartmentsAction =
  (emails, departmentIds) => async (dispatch) => {
    try {
      const res = await axios.post("/api/admin-user/bulk-assign-departments/", {
        emails,
        department_ids: departmentIds,
      });
      dispatch({
        type: BULK_ASSIGN_DEPARTMENTS_SUCCESS,
        payload: res.data,
      });
      return res.data;
    } catch (err) {
      dispatch(returnErrors(err.response?.data, err.response?.status));
      dispatch({
        type: BULK_ASSIGN_DEPARTMENTS_FAIL,
        payload: err.response?.data,
      });
      throw err;
    }
  };
